export interface IBreachDetails {
  ticketNbr: string;
  vrm: string;
  make: string;
  model: string;
  color: string;
  details: string;
  location: string;
  timeIn: string;
  offenceTime: string;
  images: string[];
  amount: number;
  status: { key: String; value: String };
}

export const BREACH_STATUS = {
  PAID: 4,
  DR_PAID_IN_FULL: 21,
  DR_PAID_SETTLEMENT: 22,
  WITH_DR: 5,
  DR_CANCELLED: 23,
};

export type BreachStatusValue =
  (typeof BREACH_STATUS)[keyof typeof BREACH_STATUS];
